import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { Close } from "@mui/icons-material";
import { CAREPMS_UPLOAD_HISTORY_ENDPOINT } from "../config/urls";

const UploadHistoryDeleteModal = ({ open, handleClose, selectedRow, onSuccess, onError }) => {
  const [loading, setLoading] = useState(false);

  const handleCancel = () => {
    if (loading) return;
    handleClose();
  };

  const handleDelete = async () => {
    if (!selectedRow) return;

    setLoading(true);
    try {
      const tenant = localStorage.getItem("tenant");
      const response = await fetch(`${CAREPMS_UPLOAD_HISTORY_ENDPOINT}${selectedRow.id}/`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json", "X-Tenant-Id": tenant },
      });

      if (!response.ok) throw new Error("Delete request failed");

      handleClose();
      onSuccess?.();
    } catch (error) {
      handleClose();
      onError?.();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleCancel} fullWidth maxWidth="sm" sx={{ zIndex: 1204 }}>
      <DialogTitle
        sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
      >
        Delete Uploaded File
        <IconButton aria-label="close" onClick={handleCancel} disabled={loading}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Are you sure you want to delete this uploaded file? This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={handleDelete} variant="contained" color="error" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : "Yes, Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UploadHistoryDeleteModal;
